export default __webpack_public_path__ + "static/media/calendar.f0bccee8.svg";